export default __webpack_public_path__ + "static/james-ownby-neat-banner-104ea0e9105680bde9c5037321dc6c19.jpg";